export var DEFAULT_MIN_WIDTH = '1280px';
//# sourceMappingURL=const.js.map